// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".regular-media svg[data-v-640a1814]{left:50%;pointer-events:none;position:absolute;top:50%;transform:translate(-50%,-50%);z-index:1}", ""]);
// Exports
module.exports = exports;
